export const baseMenuItemClassnameFromSizeHorizontal: Record<MenuSize, string> =
  {
    small: 'padding-horizontal-8',
    medium: 'padding-horizontal-8',
  }

export const baseMenuItemClassnameFromSizeVertical: Record<MenuSize, string> = {
  small: 'padding-vertical-8',
  medium: 'padding-vertical-12',
}

export type MenuSize = 'small' | 'medium'
